<template>
  <div class="modal-clone-module">
    <action-dispatcher action="product/get" :parameters="{ limit: 100 }">
      <snow-select
        v-model="product_id"
        id="product-select"
        :options="products"
        label="Selecione o produto"
      />
    </action-dispatcher>
    <action-dispatcher
      v-if="product_id"
      :key="product_id"
      action="membersModules/get"
      :parameters="{ product_id, commit: false, limit: 50 }"
      @success="setModules"
    >
      <snow-select
        v-model="module_id"
        id="module-select"
        class="mt-4"
        label="Selecione o módulo"
        :options="modules"
      />
    </action-dispatcher>
    <div class="snow-submit-buttons mt-7">
      <snow-button
        size="lg"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        text="Confirmar"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      product_id: "",
      module_id: "",
      modules: []
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return this.product_id && this.module_id;
    }
  },
  methods: {
    submit() {
      this.loading = true;
      this.$store
        .dispatch("membersModules/clone", {
          target_product: this.$route.params.id,
          module_id: this.module_id
        })
        .then(() => {
          this.$emit("close");
          this.$emit("refresh");
          this.$message.success("Módulo copiado.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setModules(v) {
      this.modules = v.data.results;
    }
  },
  watch: {
    product_id() {
      this.module_id = "";
    }
  }
};
</script>
